import colors from "vuetify/lib/util/colors";

export default {
  primary: "#1976D2",
  secondary: "#424242",
  accent: "#82B1FF",
  error: "#FF5252",
  info: "#2196F3",
  success: "#4CAF50",
  warning: "#FFC107",
  increase: "#162517", //
  light: "#E9EAEC", // grey lighten-3
  background: colors.blueGrey,
  inputColor: "#E9EAEC",
};
